import { create } from 'zustand'

// 이전 URL 정보 관련 전역 상태 관리

interface PrevStore {
  prevUrl: string | null
  set: (payload: Partial<PrevStore>) => void
  setPrevUrl: (url: string | null) => void
  destroy: () => void
}

const usePrevStore = create<PrevStore>((set) => ({
  prevUrl: null,
  set: (payload) => set((state) => ({ ...state, ...payload })),
  setPrevUrl: (prevUrl) => set({ prevUrl }),
  destroy: () => set({ prevUrl: null }),
}))

export default usePrevStore
